export default "__VITE_ASSET__02b3e7d1__"